import {clsx} from 'clsx';
import {checkMailTitleFeatureEnable} from '../press-release-editor-v3/utils/editor-version';
import styles from './view.module.css';
import {useCompanyQuery} from './api/queries/use-company-query';
import {usePressReleaseQuery} from './api/queries/use-press-release-query';
import {PreviewControlHeader} from './components/preview-control-header';
import {TestMailButton} from './components/test-mail-button';
import {PreviewUi} from './components/preview-ui';
import {showMobileExternalPreview} from './lib/parameters';
import {PasswordForm} from './components/password-form';
import {useLatestPressReleasesQuery} from './api/queries/use-latest-press-releases-query';
import {useLatestStoriesQuery} from './api/queries/use-latest-stories-query';
import {MobileExternalPreview} from './components/mobile-external-preview';
import {useShouldShowPasswordForm} from './context/should-show-password-form';
import {Head} from './components/head';
import {usePreviewDeviceState} from './hooks/use-preview-device-state';
import {SharePreviewButton} from '@/components/unfixed-new-ui/share-preview-button';

export function View() {
  /* location.hrefを見てプレビューページと外部共有ページでリクエストするAPIを切り替える */
  const {data: pressRelease} = usePressReleaseQuery();
  const {data: company} = useCompanyQuery();
  const {data: latestPressReleases} = useLatestPressReleasesQuery();
  const {data: latestStories} = useLatestStoriesQuery();
  const shouldShowPasswordForm = useShouldShowPasswordForm();
  const {device, setDevice} = usePreviewDeviceState();

  /* 認証に失敗した場合にpresReleaseとcompanyはundefinedになり、shouldShowPasswordForm が true になる */
  if (pressRelease === undefined || company === undefined || company === null) {
    if (shouldShowPasswordForm) {
      return <PasswordForm />;
    }

    return null;
  }

  // [~3.0.0] 下書き状態のプレスリリースのみ有効(予約状態は無効)
  // [^3.0.0] 予約状態によらず有効
  const isMailTitleFeatureEnable =
    Boolean(pressRelease.isDraft) ||
    checkMailTitleFeatureEnable(pressRelease.editorVersion);

  // モバイル端末で外部共有プレビューページの場合、Web・メールのみでデバイス切り替え無しのモバイルプレビューを表示
  if (showMobileExternalPreview()) {
    return (
      <div className={styles.root}>
        <Head title={pressRelease.title} companyName={company.companyName} />
        <MobileExternalPreview
          pressRelease={pressRelease}
          company={company}
          latestPressReleasesData={latestPressReleases}
          latestStoriesData={latestStories}
        />
      </div>
    );
  }

  return (
    <div className={clsx(styles.root, styles.pc)}>
      <Head title={pressRelease.title} companyName={company.companyName} />
      <PreviewControlHeader
        isNotYetDelivered={pressRelease.releaseCompleDate === null}
        deliveryStatus={pressRelease.deliveryStatus}
        editorVersion={pressRelease.editorVersion}
        renderTestMailButton={() => (
          <TestMailButton
            isMailTitleFeatureEnable={isMailTitleFeatureEnable}
            title={pressRelease.title}
            prefixMailTitle={`【${company.companyName}】${pressRelease.title}`}
            mailTitle={pressRelease.mailTitle}
            isMailTitlePrefix={pressRelease.mailTitlePrefixCompanyNameFlg}
            isMailTitleReplacing={pressRelease.mailTitleReplacingFlg}
          />
        )}
        renderSharePreviewButton={() => (
          <SharePreviewButton releaseId={pressRelease.releaseId} />
        )}
        device={device}
        setDevice={setDevice}
      />
      <PreviewUi
        pressRelease={pressRelease}
        company={company}
        latestPressReleases={latestPressReleases}
        latestStories={latestStories}
        device={device}
      />
    </div>
  );
}
